import React, { useRef, useEffect, useState, useContext } from "react";
import {
    Card,
    Row,
    Col,
    Typography,
    Table,
    Divider,
    Button,
    Image,
    Select,
    message,
    Spin,
} from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import BashyamLogo from "../assests/baashyaam_logo.png";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";

const { Title, Text } = Typography;
const { Option } = Select;

const PaySlip = () => {
    const slipRef = useRef();
    const { authData, backUrl } = useContext(AuthContext);
    const [data, setData] = useState(null);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const [loading, setLoading] = useState(false);

    // 🔹 Fetch payslip data
    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${backUrl}/api/payroll/payslip/${year}/${month}/`,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );
            setData(res.data);
            console.log("Payslip Data:", res.data);
        } catch (error) {
            console.error("Error fetching payslip:", error);

            if (error.response?.data?.detail) {
                message.error(error.response.data.detail);
            } else {
                message.error("Failed to fetch payslip data");
            }

            setData(null);
        } finally {
            setLoading(false);
        }
    };

    console.log("Authdata =>", authData)

    useEffect(() => {
        fetchData();
    }, [month, year]);

    const handleDownload = async () => {
        const element = slipRef.current;

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,        // ✅ REQUIRED
            allowTaint: false,   // ✅ safer
            backgroundColor: "#ffffff",
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`PaySlip_${month}_${year}.pdf`);
    };


    const monthOptions = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ];

    const yearOptions = [];
    for (let y = new Date().getFullYear() - 2; y <= new Date().getFullYear() + 1; y++) {
        yearOptions.push(y);
    }

    const tableHeaderStyle = {
        backgroundColor: "#0e497b",
        color: "white",
    };

    return (
        <>
            <Row gutter={[10, 10]} style={{ marginBottom: "20px" }}>
                <Col>
                    <Select value={month} onChange={setMonth} style={{ width: 160 }}>
                        {monthOptions.map((m, index) => (
                            <Option key={index + 1} value={index + 1}>
                                {m}
                            </Option>
                        ))}
                    </Select>
                </Col>

                <Col>
                    <Select value={year} onChange={setYear} style={{ width: 120 }}>
                        {yearOptions.map((y) => (
                            <Option key={y} value={y}>
                                {y}
                            </Option>
                        ))}
                    </Select>
                </Col>

                <Col>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={handleDownload}
                        style={{ backgroundColor: "#0e497b", borderColor: "#0e497b" }}
                        disabled={!data}
                    >
                        Download Pay Slip
                    </Button>
                </Col>
            </Row>

            {/* LOADING */}
            {loading && <Spin tip="Loading Payslip..." />}

            {/* NO DATA */}
            {!loading && !data && (
                <Text style={{ fontSize: 16, color: "red" }}>
                    No payslip found for the selected month/year.
                </Text>
            )}

            {/* PAYSLIP TEMPLATE */}
            {!loading && data && (
                <div ref={slipRef}>
                    <Card
                        style={{
                            width: "900px",
                            margin: "0 auto",
                            padding: "40px",
                            border: "1px solid #000",
                            fontFamily: "Arial, sans-serif",
                        }}
                    >
                        {/* HEADER */}
                        <Table
                            columns={[
                                {
                                    dataIndex: "logo",
                                    key: "logo",
                                    width: 100,
                                    render: () => (
                                        <Image
                                            src={BashyamLogo}
                                            alt="Baashyaam Logo"
                                            width={150}
                                            preview={false}
                                        />
                                    ),
                                },
                                {
                                    dataIndex: "info",
                                    key: "info",
                                    align: "center",
                                    render: () => (
                                        <>
                                            <Title level={4} style={{ margin: 0, color: "#0e497b" }}>
                                                {data?.employee?.organisation_name?.toUpperCase() ||
                                                    "BAASHYAAM DEVELOPERS PVT LTD"}
                                            </Title>
                                            <Text style={{ fontSize: '12px' }}>No.87, GN CHETTY ROAD, CHENNAI 600017</Text>
                                        </>
                                    ),
                                },
                                {
                                    dataIndex: "empImg",
                                    key: "empImg",
                                    width: 100,
                                    render: () => (
                                        <Image
                                            src={`${authData?.employee?.photo}`}
                                            alt="Employee Image"
                                            width={100}
                                            height={90}
                                            preview={false}
                                        />
                                    ),
                                },
                            ]}
                            dataSource={[{ key: "1" }]}
                            pagination={false}
                            bordered={false}
                            showHeader={false}
                        />

                        <center>
                            <Text strong>
                                PAY SLIP FOR THE MONTH OF {monthOptions[month - 1].toUpperCase()} {year}
                            </Text>
                        </center>

                        {/* EMPLOYEE DETAILS */}
                        <Table
                            bordered
                            pagination={false}
                            showHeader={false}
                            style={{ marginBottom: "10px" }}
                            dataSource={[
                                {
                                    key: 1,
                                    col1: <Text strong>Employee Name:</Text>,
                                    col2: `${data?.employee?.first_name || ""} ${data?.employee?.last_name || ""}`,
                                    col3: <Text strong>PF UAN:</Text>,
                                    col4: data?.employee?.uan_number || "-",
                                },
                                {
                                    key: 2,
                                    col1: <Text strong>Designation:</Text>,
                                    col2: data?.employee?.designation_name || "-",
                                    col3: <Text strong>ESIC IP No:</Text>,
                                    col4: data?.employee?.esic_ip_number || "-",
                                },
                                {
                                    key: 3,
                                    col1: <Text strong>Department:</Text>,
                                    col2: data?.employee?.department_name || "-",
                                    col3: <Text strong>Location:</Text>,
                                    col4: data?.employee?.location || "-",
                                },
                                {
                                    key: 4,
                                    col1: <Text strong>EMP Code:</Text>,
                                    col2: data?.employee?.emp_code || "-",
                                    col3: <Text strong>PAN:</Text>,
                                    col4: data?.employee?.pan_card_number || "-",
                                },
                                {
                                    key: 5,
                                    col1: <Text strong>Date of Joining:</Text>,
                                    col2: data?.employee?.date_of_joining || "-",
                                    col3: <Text strong>Month Days:</Text>,
                                    col4: data?.final_statement?.month_days || "-",
                                },
                                {
                                    key: 6,
                                    col1: <Text strong>Bank Name:</Text>,
                                    col2: data?.employee?.branch_name || "-",
                                    col3: <Text strong>Payable Days:</Text>,
                                    col4: data?.final_statement?.days_payable || "-",
                                },
                                {
                                    key: 7,
                                    col1: <Text strong>Bank A/C No:</Text>,
                                    col2: data?.employee?.bank_account_number || "-",
                                    col3: <Text strong>LOP:</Text>,
                                    col4: data?.final_statement?.lop_days || "-",
                                },
                            ]}
                            columns={[
                                { dataIndex: "col1", key: "col1" },
                                { dataIndex: "col2", key: "col2" },
                                { dataIndex: "col3", key: "col3" },
                                { dataIndex: "col4", key: "col4" },
                            ]}
                        />

                        {/* LEAVE BALANCES */}

                        {/* <Divider /> */}

                        {/* EARNINGS & DEDUCTIONS */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <center><Title level={5}>Earnings</Title></center>

                                <Table
                                    bordered
                                    pagination={false}
                                    size="small"
                                    dataSource={[
                                        { key: 1, name: "Basic Salary", amount: data?.final_statement?.basic_earned },
                                        { key: 2, name: "HRA", amount: data?.final_statement?.hra_earned },
                                        { key: 3, name: "Conveyance Allowance", amount: data?.final_statement?.conveyance_earned },
                                        { key: 4, name: "Other Allowance", amount: data?.final_statement?.other_allowance_earned },
                                        { key: 5, name: "OT Pay", amount: data?.final_statement?.ot_pay },
                                        { key: 6, name: "Arrears", amount: data?.final_statement?.arrears },
                                    ]}
                                    columns={[
                                        { title: "Particulars", dataIndex: "name" },
                                        {
                                            title: "Amount (₹)",
                                            dataIndex: "amount",
                                            align: "right",
                                            render: (v) => parseFloat(v || 0).toLocaleString(),
                                        },
                                    ]}
                                    components={{
                                        header: {
                                            cell: (props) => (
                                                <th {...props} style={tableHeaderStyle}>
                                                    {props.children}
                                                </th>
                                            ),
                                        },
                                    }}
                                />

                                <Text strong style={{ float: "right", marginTop: 10 }}>
                                    Gross Earnings: ₹{parseFloat(data?.final_statement?.gross_earned || 0).toLocaleString()}
                                </Text>
                            </Col>

                            <Col span={12}>
                                <center><Title level={5}>Deductions</Title></center>

                                <Table
                                    bordered
                                    pagination={false}
                                    size="small"
                                    dataSource={[
                                        { key: 1, name: "PF Employee", amount: data?.final_statement?.pf_employee },
                                        { key: 2, name: "ESI Employee", amount: data?.final_statement?.esi_employee },
                                        { key: 3, name: "Professional Tax", amount: data?.final_statement?.professional_tax },
                                        { key: 4, name: "Salary Advance", amount: data?.final_statement?.salary_advance },
                                        { key: 5, name: "Other Deductions", amount: data?.final_statement?.other_deductions },
                                        { key: 5, name: "LOP Deduction", amount: data?.final_statement?.lop_deduction },
                                        { key: 5, name: "PT Deduction", amount: 208 },
                                    ]}
                                    columns={[
                                        { title: "Particulars", dataIndex: "name" },
                                        {
                                            title: "Amount (₹)",
                                            dataIndex: "amount",
                                            align: "right",
                                            render: (v) => parseFloat(v || 0).toLocaleString(),
                                        },
                                    ]}
                                    components={{
                                        header: {
                                            cell: (props) => (
                                                <th {...props} style={tableHeaderStyle}>
                                                    {props.children}
                                                </th>
                                            ),
                                        },
                                    }}
                                />

                                <Text strong style={{ float: "right", marginTop: 10 }}>
                                    Total Deductions: ₹{parseFloat(data?.final_statement?.total_deductions || 0).toLocaleString()}
                                </Text>
                            </Col>
                        </Row>

                        <Divider />

                        {/* NET PAY */}
                        <Row>
                            <Col span={12}>
                                <Title level={5} style={{ color: "#0e497b" }}>
                                    NET PAY
                                </Title>
                            </Col>

                            <Col span={12} style={{ textAlign: "right" }}>
                                <Title level={5} style={{ color: "#0e497b" }}>
                                    ₹{parseFloat(data?.final_statement?.net_pay || 0).toLocaleString()}
                                </Title>
                            </Col>
                        </Row>

                        <Text strong>{data?.final_statement?.net_pay_in_words}</Text>

                        <Divider />

                        <Table
                            bordered
                            pagination={false}
                            dataSource={[
                                {
                                    key: 1,
                                    leave: "Casual Leave",
                                    opening: data?.leave_balance[0].opening ?? 0,
                                    availed: data?.leave_balance[0].availed ?? 0,
                                    balance: data?.leave_balance[0].balance ?? 0,
                                },
                                {
                                    key: 2,
                                    leave: "Sick Leave",
                                    opening: data?.leave_balance[1].opening ?? 0,
                                    availed: data?.leave_balance[1].availed ?? 0,
                                    balance: data?.leave_balance[1].balance ?? 0,
                                },
                                // {
                                //     key: 3,
                                //     leave: "Earned Leave",
                                //     opening: data?.leave_balance?.el_opening ?? 0,
                                //     availed: data?.leave_balance?.el_availed ?? 0,
                                //     balance: data?.leave_balance?.el_balance ?? 0,
                                // },
                            ]}
                            columns={[
                                { title: "Leave Type", dataIndex: "leave", align: "center" },
                                { title: "Opening", dataIndex: "opening", align: "center" },
                                { title: "Availed", dataIndex: "availed", align: "center" },
                                { title: "Balance", dataIndex: "balance", align: "center" },
                            ]}
                            components={{
                                header: {
                                    cell: (props) => (
                                        <th {...props} style={tableHeaderStyle}>
                                            {props.children}
                                        </th>
                                    ),
                                },
                            }}
                            style={{ marginBottom: "10px" }}
                        />

                        <Divider />

                        <center>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                This is a system-generated payslip and does not require a signature.
                            </Text>
                        </center>
                    </Card>
                </div>
            )}
        </>
    );
};

export default PaySlip;
